"use client"

import type { EffectivePrintTemplate, PrintInventoryType, PrintTemplate } from '@repo/types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { printTemplatesService } from '@repo/ui/lib/api/services/print-templates.service';

export const printTemplatesKeys = {
  effective: (type: PrintInventoryType) => ['print-templates', type] as const,
};

/** Modèle de fiche de l'organisation. Toujours relu à l'ouverture : un modèle enregistré ailleurs doit s'appliquer tout de suite. */
export function useEffectivePrintTemplate(type: PrintInventoryType, enabled = true) {
  return useQuery({
    queryKey: printTemplatesKeys.effective(type),
    queryFn: () => printTemplatesService.effective(type),
    enabled,
    staleTime: 0,
    retry: 1,
  });
}

export function useSavePrintTemplate(type: PrintInventoryType) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ config, expectedRevision }: { config: PrintTemplate; expectedRevision: number }) =>
      printTemplatesService.save(type, config, expectedRevision),
    onSuccess: (saved: EffectivePrintTemplate) => queryClient.setQueryData(printTemplatesKeys.effective(type), saved),
  });
}

export function useResetPrintTemplate(type: PrintInventoryType) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => printTemplatesService.reset(type),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: printTemplatesKeys.effective(type) }),
  });
}
